module.exports = __webpack_public_path__ + "static/img/3_4.76eddfb4.jpg";